import type { AIChatPaywallMessage } from '@store/reducers/ai/types'
import type React from 'react'

import { useOpenUpgradeModal } from '../../../../hooks'
import { ActionButton, ActionsMessage, AIMessage } from '../../../index'

interface PaywallMessageProps {
  message: AIChatPaywallMessage
}

// v2 (chat-agent): rendered when the agent hits PLAN_REQUIRED — the paywall
// text plus an "Upgrade" chip opening the upgrade modal (same flow as
// RemainingLimits).
export const PaywallMessage: React.FC<PaywallMessageProps> = ({ message }) => {
  const onUpgradeClick = useOpenUpgradeModal()

  return (
    <>
      <AIMessage>{message.text}</AIMessage>
      <ActionsMessage>
        <ActionButton variant="purple" onClick={onUpgradeClick}>
          Upgrade
        </ActionButton>
      </ActionsMessage>
    </>
  )
}
